import { useEffect } from 'react';
import { messaging, getToken } from '@core/services/firebase/firebase-config';

const RequestNotificationPermission = () => {
    useEffect(() => {
        const requestPermission = async () => {
            try {
                const currentToken = await getToken(messaging, { vapidKey: window._env_.FIREBASE_VAPID_KEY });
                if (currentToken) {
                    console.log('Got FCM device token:', currentToken);
                } else {
                    console.log('No registration token available. Request permission to generate one.');
                }
            } catch (err: any) {
                console.error('An error occurred while retrieving token. ', err);
                if (err.code === 'messaging/token-unsubscribe-failed') {
                    console.error('Token unsubscribe failed:', err.message);
                } else {
                    console.error('Other error occurred:', err.message);
                }
            }
        };

        requestPermission();
    }, []);

    return null;
};

export default RequestNotificationPermission;
